import React, { useEffect, useState } from "react"
import axios from 'axios'
import { useNavigate, Link, useSearchParams } from 'react-router-dom'
import { handleChange, handleBlur, setInputValues } from '../../components/Form'
import PulseLoader from "react-spinners/PulseLoader"
import { setCookie } from "../../helpers/helpers"
import '../../style/auth/auth.css'

const Signup = () => {
    const [buttonText, setButtonText] = useState('Vytvoriť bezplatný účet')
    const [error, setError] = useState('')
    const [values, setValues] = useState()
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()
    const i = searchParams.get("i")

    useEffect(() => {
        setInputValues(['email', 'firstname', 'lastname', 'password', 'phone', 'birthyear'], setValues)
    }, [])

    const handleSubmit = (event) => {
        event.preventDefault()
        setButtonText('loader')
        const { email, firstname, lastname, password, phone, birthyear } =
            Object.keys(values).reduce((obj, key) => { obj[key] = values[key].value; return obj; }, {})
        axios({
            method: 'POST',
            url: `${process.env.REACT_APP_API}/auth/signup`,
            data: { email, firstname, lastname, phone, birthyear, password, invited_by: i ? i : 'INVITED_BY_ME' },
        })
            .then(response => {
                setCookie('token', response.data.token)
                navigate('/home')
            })
            .catch(error => {
                let copyOfValues = values
                copyOfValues.password.value = ''
                Object.keys(copyOfValues).map(key => copyOfValues[key].isActivated = false)
                setValues(copyOfValues)
                setButtonText('Vytvoriť bezplatný účet')
                if (error?.response?.data?.error && typeof error.response.data.error === 'string') {
                    setError(error.response.data.error)
                }
            })
    }

    const field = (name, type, placeholder, label) => (
        <div className="auth-field">
            <label className="auth-label">{label}</label>
            <input
                className="auth-input"
                type={type}
                name={name}
                placeholder={placeholder}
                value={values?.[name]?.value || ''}
                onChange={e => handleChange(e, values, setValues)}
                onBlur={e => handleBlur(e, values, setValues)}
            />
        </div>
    )

    return (
        <div className="auth-page">
            <a href="/" className="auth-logo">Arbitrage<span>.sk</span></a>

            <div className="auth-card">
                <h1 className="auth-title">Začnite zarábať zadarmo</h1>
                <p className="auth-subtitle">Žiadna kreditná karta. Prístup k arbitrážam ihneď.</p>

                <form onSubmit={handleSubmit}>
                    {field('email', 'email', 'vas@email.sk', 'Email')}

                    <div className="auth-row">
                        {field('firstname', 'text', 'Ján', 'Krstné meno')}
                        {field('lastname', 'text', 'Novák', 'Priezvisko')}
                    </div>

                    <div className="auth-row">
                        {field('phone', 'text', '+421 9XX XXX XXX', 'Telefón')}
                        {field('birthyear', 'text', 'napr. 1995', 'Rok narodenia')}
                    </div>

                    {field('password', 'password', 'Minimálne 8 znakov', 'Heslo')}

                    <div className="auth-error">{error}</div>

                    <button className="auth-btn" type="submit" disabled={buttonText === 'loader'}>
                        {buttonText === 'loader'
                            ? <PulseLoader color="#fff" size={8} margin={4} speedMultiplier={0.9} />
                            : <><i className="fas fa-rocket"></i> {buttonText}</>
                        }
                    </button>
                </form>
            </div>

            <p className="auth-footer">
                Už máš účet? <Link to="/signin">Prihlásiť sa</Link>
            </p>

            <div className="auth-trust">
                <span className="auth-trust-item"><i className="fas fa-lock"></i> 100% bezpečné</span>
                <span className="auth-trust-item"><i className="fas fa-check"></i> 100% legálne</span>
                <span className="auth-trust-item"><i className="fas fa-times-circle"></i> Bez záväzkov</span>
            </div>
        </div>
    )
}

export default Signup
